export default __webpack_public_path__ + "static/media/veme-app-ui-design.a2b88dd7.png";